import React, { useEffect, useState } from 'react';
import { Modal, Select } from 'antd';
import { theme } from 'utils/style/theme';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import iconClose from 'utils/icon/icon_close_circle.svg';
import PrimaryButton from 'components/button/PrimaryButton';
import InputStyled from 'components/InputStyled';
import {
  IAbility,
  IAbilityLocalization,
  IItem,
  IItemLocalize,
  IModalVisible,
  ISupportLanguage,
} from 'utils/types/storyTypes';
import SelectStyled from 'components/SelectStyled';

/**
 * * 다국어 지원 테이블의 언어 추가 모달
 */

interface IProps {
  visibleState: IModalVisible; // 팝업 활성, 비활성 정보
  setVisibleState: React.Dispatch<React.SetStateAction<IModalVisible>>;

  langList: ISupportLanguage[];

  targetData: IItem | IAbility | null; // 로컬라이징 정보를 포함하고있는 대상정보 (item, profile 등등)
  setTargetData: React.Dispatch<React.SetStateAction<any>>; // 타겟 데이터 state 처리용

  firstColumnName: string;
  currentLocalDataArray: any[] | undefined;
}

const AddModal = ({
  langList,

  targetData,
  setTargetData,

  visibleState,
  setVisibleState,

  firstColumnName,
  currentLocalDataArray,
}: IProps) => {
  const { t } = useTranslation();
  const [inputValue, setInputValue] = useState<string>('');
  const [langSelect, setLangSelect] = useState<any>(null);

  const [currentLangList, setCurrentLangList] =
    useState<ISupportLanguage[]>(langList);

  const handleSubmit = async () => {
    if (!targetData) return;

    const cloneData = structuredClone(targetData);

    console.log(`다국어추가 CloneData 체크 : `, cloneData);

    if ('ability_name' in cloneData) {
      // 능력의 경우
      // ability
      cloneData.localizations.push({
        lang: langSelect,
        ability_name: inputValue,
      });
    } else if ('item_type' in cloneData) {
      // 아이템의 경우
      cloneData.localizations.push({
        lang: langSelect,
        item_name: inputValue,
      });
    }

    // cloneData.localizations.push({
    //   lang: langSelect,
    //   item_name: inputValue,
    // });

    setTargetData(cloneData);

    closeModal();
  };

  /// 모달 닫기
  const closeModal = () => {
    setVisibleState({ ...visibleState, create: false });
    setInputValue('');
    setLangSelect(null);
    // 폼을 비워줘야 이미지 첨부한 것도 비워진다.
  };

  const handleInputChange = (value) => {
    setInputValue(value);
  };

  const handleLanguageChange = (e) => {
    console.log(`handleLanguageChange : `, e);
    setLangSelect(e);
  };

  // *
  useEffect(() => {
    console.log(`two column lang supporter : `, currentLocalDataArray);
    console.log(`two column lang list : `, langList);

    // TODO useEffect에 넣으면 안됨..

    const cloneLangList: ISupportLanguage[] = [];

    langList.forEach((item) => {
      let isExists = false;

      if (!currentLocalDataArray) return;

      for (let i = 0; i < currentLocalDataArray.length; i++) {
        if (currentLocalDataArray[i].lang == item.code) {
          isExists = true;
          break;
        }
      }

      if (!isExists) {
        cloneLangList.push(item);
      }
    });

    setCurrentLangList(cloneLangList);
  }, [targetData, currentLocalDataArray]);

  return (
    <CustomModal
      title={'신규 항목 생성'}
      open={visibleState.create}
      onCancel={closeModal}
      footer={
        <ButtonWrapper>
          <PrimaryButton
            text={t('buttons.create')}
            height='40px'
            width='fit-content'
            bgColor={theme.colors.blue_500}
            textColor='#ffffff'
            fontWeight={theme.fontWeights.medium}
            fontSize={theme.fontSizes.normal}
            border={`1px solid ${theme.colors.blue_500}`}
            rounded='6px'
            hoverBgColor={theme.colors.blue_600}
            activeBgColor={theme.colors.blue_800}
            selectedBgColor={theme.colors.blue_700}
            onClick={handleSubmit}
          />
        </ButtonWrapper>
      }
      closeIcon={
        <img src={iconClose} width={20} height={20} alt='icon-close' />
      }
    >
      <SectionWarpper>
        <div>
          <p className='title'>지원 언어</p>
          <SelectStyled
            value={langSelect}
            size='large'
            bordered={false}
            // suffixIcon={
            //   <img src={isOpen ? arrowUp : arrowDown} alt="arrow" />
            // }
            style={{ width: '100%' }}
            onChange={(e) => {
              handleLanguageChange(e);
            }}
            options={currentLangList?.map((v, i) => {
              return {
                value: v.code,
                label: v.code_name,
              };
            })}
          />
        </div>
        <div>
          <p className='title'>{firstColumnName}</p>
          <InputStyled
            value={inputValue}
            onChange={(e) => {
              handleInputChange(e.target.value);
            }}
            maxLength={30}
          />
          <p className='length-subtext'>
            {typeof inputValue.length === 'number'
              ? `${inputValue.length}/30 characters`
              : '0/30 characters'}
          </p>
        </div>
      </SectionWarpper>
    </CustomModal>
  );
};

export default AddModal;

const CustomModal = styled(Modal)`
  .ant-modal-body {
    padding: 0;
  }
  .ant-modal-content {
    box-shadow: none;
    width: 566px;
  }
  .ant-radio-wrapper {
    span {
      font-size: ${theme.fontSizes.normal};
      font-weight: 400;
      line-height: 24px;
      letter-spacing: 0.2px;
      color: ${theme.colors.dark_500};
    }
  }
  .ant-modal-footer {
    margin-top: 10px !important;
  }
  ul {
    margin-left: 25px;
  }
  .ant-modal-close:hover {
    background-color: transparent;
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: end;
`;

const SectionWarpper = styled.div`
  & > * + * {
    margin-top: 8px;
  }
  .checkbox-section {
    display: flex;
    align-items: center;
    & > * + * {
      margin-left: 48px;
    }
  }
  .checkbox-item {
    display: flex;
    align-items: center;
    p {
      font-size: ${theme.fontSizes.sm};
      font-weight: ${theme.fontWeights.normal};
      line-height: 20px;
      letter-spacing: 0.2px;
      color: #000000;
    }
    & > * + * {
      margin-left: 8px;
    }
  }
`;
